module.exports = __webpack_public_path__ + "DejaVuSans-Oblique.8723fc16d3649200d617.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/muhammadfiqihfirdiansyah/Documents/Muhammad Fiqih Firdiansyah/Project/Angular/BODES/BODES.Web.UI.Angular4/external_css/kendo-ui/fonts/DejaVu/DejaVuSans-Oblique.ttf?v=1.1
// module id = ../../../../../external_css/kendo-ui/fonts/DejaVu/DejaVuSans-Oblique.ttf?v=1.1
// module chunks = styles